import { render, staticRenderFns } from "./AdminLive.vue?vue&type=template&id=fd76b260&"
import script from "./AdminLive.vue?vue&type=script&lang=js&"
export * from "./AdminLive.vue?vue&type=script&lang=js&"
import style0 from "./AdminLive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports